<div class="calculator__right second-right third-right">
  <div>
    <div class="calculator__right-top">
        <div class="calculator__right-title">Заказчик перевозки</div>
    </div>

    <el-form-item prop="thirdPerson.cargoTransportationCustomer">
      <el-form-item
        prop="dataForm.thirdPerson.cargoTransportationCustomer"
      >
        <el-radio-group
          class="calculator__payer__buttons calculator__payer__buttons_type_three mb-40"
          v-model="dataForm.thirdPerson.cargoTransportationCustomer"
          @change="clearThirdPerson"
        >
          <el-radio-button
            v-for="option in optionsWhoPays"
            :key="option.value"
            :label="option.value"
            class="calculator__payer__button"
            @click="e => e.target.parentNode.classList.remove('is-focus')"
          >{{ option.label }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form-item>

    <template
      v-if="dataForm.thirdPerson.cargoTransportationCustomer === 'Третье лицо'"
    >
      <el-form-item prop="thirdPerson.typeThirdPerson">
        <el-form-item prop="dataForm.thirdPerson.typeThirdPerson">
          <el-radio-group
            class="calculator__payer__buttons calculator__payer__buttons_type_three mb-40"
            v-model="dataForm.thirdPerson.typeThirdPerson"
            @change="thirdPersonTypeChange"
          >
            <el-radio-button
              v-for="option in optionsPersonTypeLegal"
              :key="option.value"
              :label="option.value"
              class="calculator__payer__button"
              @click="e => e.target.parentNode.classList.remove('is-focus')"
            >{{ option.label }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form-item>

      <el-form-item
        v-if="dataForm.thirdPerson.typeThirdPerson"
        class="calculator__form-item"
      >
        <el-form-item
          prop="thirdPerson.innThirdPerson"
          class="calculator__form-item"
        >
          <el-input
            :placeholder="dataForm.thirdPerson.typeThirdPerson === 2 ? 'ИНН/БИН' : 'ИНН'"
            v-model="dataForm.thirdPerson.innThirdPerson"
            v-mask="INN_MASK"
            :maxlength="dataForm.thirdPerson.typeThirdPerson === 2 ? 12 : 10"
            autocomplete="email"
            @change="getNameOrganization('thirdPerson', dataForm.thirdPerson.innThirdPerson)"
          />
        </el-form-item>

        <el-form-item
          v-if="dataForm.thirdPerson.typeThirdPerson == 1"
          prop="thirdPerson.kppThirdPerson"
          class="calculator__form-item"
        >
          <el-input
            placeholder="КПП"
            v-model="dataForm.thirdPerson.kppThirdPerson"
            v-mask="KPP_MASK"
            autocomplete="email"
            @change="getNameOrganization('thirdPerson', dataForm.thirdPerson.kppThirdPerson)"
          />
        </el-form-item>

        <el-form-item
          prop="thirdPerson.name"
          class="calculator__form-item"
        >
          <el-input placeholder="Наименование организации" type="text" autocomplete="on" v-model="dataForm.thirdPerson.name" />
        </el-form-item>
      </el-form-item>

      <el-form-item
        v-if="!dataForm.thirdPerson.typeThirdPerson"
        class="calculator__form-item"
      >
          <el-form-item prop="thirdPerson.surnameThirdPerson" class="calculator__form-item">
            <el-autocomplete
              :fetch-suggestions="getSurNameSearch"
              @input="getSurName"
              clearable
              placeholder="Фамилия"
              autocomplete="family-name"
              :trigger-on-focus="false"
              v-model="dataForm.thirdPerson.surnameThirdPerson"
              @keyup="dataForm.thirdPerson.surnameThirdPerson = limitInput(dataForm.thirdPerson.surnameThirdPerson)"
            />
          </el-form-item>
          <el-form-item prop="thirdPerson.firstNameThirdPerson" class="calculator__form-item">
            <el-autocomplete
              v-model="dataForm.thirdPerson.firstNameThirdPerson"
              @keyup="dataForm.thirdPerson.firstNameThirdPerson = limitInput(dataForm.thirdPerson.firstNameThirdPerson)"
              :fetch-suggestions="getFirstNameSearch"
              @input="getName"
              clearable
              placeholder="Имя"
              :trigger-on-focus="false"
            />
          </el-form-item>
          <el-form-item prop="thirdPerson.secondNameThirdPerson" class="calculator__form-item">
            <el-autocomplete
            v-model="dataForm.thirdPerson.secondNameThirdPerson"
            @keyup="dataForm.thirdPerson.secondNameThirdPerson = limitInput(dataForm.thirdPerson.secondNameThirdPerson)"
              :fetch-suggestions="getSecondNameSearch"
              @input="getSecondName"
              clearable
              placeholder="Отчество"
              autocomplete="additional-name"
              :trigger-on-focus="false"
            />
          </el-form-item>
      </el-form-item>

      <el-form-item class="form-group">
          <el-form-item
            label="Телефон"
            prop="thirdPerson.phoneThirdPerson"
            class="calculator__form-item"
          >
            <el-input
              v-model="dataForm.thirdPerson.phoneThirdPerson"
              v-mask="PHONE_MASK"
              type="tel"
              :formatter="(value) => `${value}`.replace(/\(89/g, '9')"
              :placeholder="PHONE_PLACEHOLDER"
            />
          </el-form-item>
          <el-form-item
            type="email"
            label="Эл. почта"
            prop="thirdPerson.emailThirdPerson"
            class="calculator__form-item"
            :required="dataForm.thirdPerson.typeThirdPerson"
          >
            <el-input type="email" autocomplete="email" v-model="dataForm.thirdPerson.emailThirdPerson" />
          </el-form-item>
      </el-form-item>
    </template>
  </div>
</div>

<div class="calculateArrow">
  <div class="step-counter">3/{{ dataForm.totalSteps }}</div>
  <div class="arrows-steps-prev" @click="$emit('click-button-back')"></div>
  <div class="arrows-steps-next"
  @click="$emit('click-button-next', [...getArrayOfRules((({ officeFrom, ...object }) => object)(dataForm.sender), 'sender'), ...getArrayOfRules((({ officeTo, ...object }) => object)(dataForm.consignee), 'consignee'), ...getArrayOfRules(dataForm.thirdPerson, 'thirdPerson')])"
  >
  </div>
</div>